// ABOUTME: Zod validation schemas and types for TechLog → Rusada flight transformation.
import {
  ZRusadaTechLogInput,
  ZRusadaRegistrationResponse,
  ZRusadaPlacesResponse,
  ZRusadaFlightTypeResponse,
  ZRusadaTechLogCategoriesResponse,
  ZRusadaRegistrationLifeCodesResponse,
} from '../../../../activities/api/rusada/rusada.zod';
import { ZTechlogAircraftWithType } from '../../../../types/techLog/aircraft.zod';
import { ZTechLogSector } from '../../../../types/techLog/sector.zod';
import { ZTechLogTrip } from '../../../../types/techLog/trip.zod';
import { z } from 'zod';

const ZTechlogAdditionalCrew = z.object({
  id: z.string(),
  tripId: z.string(),
  personId: z.string(),
  personRoleId: z.string(),
});

/**
 * Input validation schema for TechLog → Rusada flight transformation.
 * Uses flat structure: source.objectName and destination.objectName
 */
export const ZTechLogToRusadaFlightInput = z.object({
  techlog: z.object({
    sector: ZTechLogSector,
    trip: ZTechLogTrip.optional(),
    aircraft: ZTechlogAircraftWithType.optional(),
    additionalCrew: z.array(ZTechlogAdditionalCrew),
  }),
  rusada: z.object({
    registration: ZRusadaRegistrationResponse,
    airportDeparture: ZRusadaPlacesResponse.nullable(),
    airportArrival: ZRusadaPlacesResponse.nullable(),
    airportActualArrival: ZRusadaPlacesResponse.optional().nullable(),
    techLogCategories: ZRusadaTechLogCategoriesResponse,
    flightTypes: z.array(ZRusadaFlightTypeResponse).optional(),
    registrationLifeCodes: ZRusadaRegistrationLifeCodesResponse.optional(),
  }),
});

export const ZTechLogToRusadaFlightOutput = ZRusadaTechLogInput;

// Type exports - inferred from Zod schemas (single source of truth)
export type TechLogToRusadaFlightInput = z.infer<
  typeof ZTechLogToRusadaFlightInput
>;
export type TechLogToRusadaFlightOutput = z.infer<
  typeof ZTechLogToRusadaFlightOutput
>;
